import React, { ReactNode, forwardRef, ReactElement, Ref } from 'react';
import { TransitionProps } from '@mui/material/transitions';
import {
  Dialog,
  Slide,
  TextField,
  Box,
  Card,
  Typography,
  useMediaQuery,
  useTheme,
  Grid,
  CardActionArea,
} from '@mui/material';
import { cardHeaderSx, cardSx, mobileCardSx } from 'utils';
import { useTranslation } from 'react-i18next';
import FormButtons from 'components/buttons/FormButtons';

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement<any, any>;
  },
  ref: Ref<unknown>,
) {
  return <Slide direction='left' ref={ref} {...props} />;
});

interface CreateViolationProps {
  open: boolean;
  handleCancel: () => void;
  name: string;
  description: string;
  setName: (name: string) => void;
  setDescription: (description: string) => void;
  handleSubmit: () => void;
}

const CreateViolation = ({
  open,
  handleCancel,
  name,
  description,
  setName,
  setDescription,
  handleSubmit,
}: CreateViolationProps): ReactNode => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { palette } = theme;
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      scroll={'body'}
      fullWidth
      fullScreen={isMobile}
      aria-label={t('buttons.create', {
        name: t('violation.label'),
      })}
      maxWidth={'xs'}
    >
      <Card raised sx={isMobile ? mobileCardSx : cardSx}>
        <CardActionArea sx={cardHeaderSx}>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant={'h4'}
              sx={{
                color: palette.secondary.contrastText,
                textAlign: 'left',
              }}
            >
              {t('buttons.create', {
                name: t('violation.label', { ns: 'entities' }),
              })}
            </Typography>
          </Box>
        </CardActionArea>
        <Grid container width={'100%'} spacing={1.5} sx={{ p: 2 }}>
          <Grid size={12}>
            <TextField
              onChange={(e) => setName(e.target.value)}
              value={name}
              margin='none'
              name={'name'}
              label={t('violation.name', { ns: 'entities' })}
              variant='outlined'
              fullWidth
              required
            />
          </Grid>
          <Grid size={12}>
            <TextField
              onChange={(e) => setDescription(e.target.value)}
              value={description}
              name={'description'}
              label={t('violation.description', { ns: 'entities' })}
              margin='none'
              variant='outlined'
              fullWidth
            />
          </Grid>
          <Grid size={12}></Grid>
        </Grid>
        <FormButtons
          disableSubmit={!name}
          handleCancelAction={handleCancel}
          handleSubmitAction={handleSubmit}
          submitButtonLabel={t('buttons.create', {
            name: t('violation.label', { ns: 'entities' }),
          })}
          cancelButtonLabel={t('cancel')}
        />
      </Card>
    </Dialog>
  );
};
export default CreateViolation;
